import { render, staticRenderFns } from "./completeOrder.vue?vue&type=template&id=4676f2d7&scoped=true&"
import script from "./completeOrder.vue?vue&type=script&lang=js&"
export * from "./completeOrder.vue?vue&type=script&lang=js&"
import style0 from "./completeOrder.vue?vue&type=style&index=0&id=4676f2d7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4676f2d7",
  null
  
)

export default component.exports